import { put, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { allocationsBulkAction, updateAllocatedMembersAction } from '../actions';
import { bulkActions, setAllocatedMembers } from '../slices';
function* allocationBulkAction(action) {
    try {
        const { payload: { actionsMap, relativeDate, isHoursPerWeek } } = action;
        yield put(bulkActions({
            actionsMap,
            relativeDate,
            isHoursPerWeek
        }));
    } catch (error) {
        logger.error('an error on updating allocations', {
            error
        });
    }
}
export function* watchAllocationBulkActionSaga() {
    yield takeLatest(allocationsBulkAction.type, allocationBulkAction);
}
function* updateAllocatedMembers(action) {
    try {
        const { payload } = action;
        yield put(setAllocatedMembers(payload));
    } catch (error) {
        logger.error('an error on updating allocated members', {
            error
        });
    }
}
export function* watchUpdateAllocatedMemberSaga() {
    yield takeLatest(updateAllocatedMembersAction.type, updateAllocatedMembers);
}
